import * as React from 'react';
import { css } from '@emotion/core';
import LocalDiv from '../../localization/LocalDiv';
import { COLORS } from '../../globalStyle/colors';
import ClamShell from '../../layout/ClamShell';
import Spacer from '../../layout/Spacer';
import { FLEX_ROW, FLEX_COLUMN } from '../../layout/flexBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';


const styles = {
  msgBar: css`
    background-color: ${COLORS.WHITE};
    padding: 8px;
    border: 0 none;
    min-height: 50px;
    border-radius: 8px;
    margin-bottom: 20px;
  `,
  msgContainer:    css`
      align-items: center;
      margin: auto 8px;
    `,
};


type Props = {
  show: boolean;
  iconImage: IconProp;
  iconColor: string;
  message: React.ReactNode;
  className?: string;
};


/**
 * CreateSurvey: a component that shows messages regarding the creation of a feedback survey
 *
 * PureComponent: true
 * Redux Connected: false
 */
const CreateSurveyMessageBar: React.FC<Props> = props => (
  <div css={[FLEX_ROW, styles.msgBar]}>
    <ClamShell
      show={props.show}
      css={[FLEX_ROW, styles.msgContainer]}
    >
      <FontAwesomeIcon 
        icon={props.iconImage}
        css={css`color: ${props.iconColor};`}
        size={'2x'}
      />
      <Spacer sizePx={10} />
      <LocalDiv css={FLEX_COLUMN}>
        {props.message}
      </LocalDiv>
    </ClamShell>
  </div>
);


export default CreateSurveyMessageBar;
